import React from 'react';
import { contactDetails } from '../../constants/Constants';

const ContactDetails = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 my-8 max-w-lg mx-auto md:mx-0">
      <div className="flex items-center gap-4">
        <span className="font-semibold text-gray-800 dark:text-gray-100 min-w-[100px]">Experience:</span>
        <span className="text-gray-600 dark:text-gray-300">{contactDetails.experience}</span>
      </div>
      <div className="flex items-center gap-4">
        <span className="font-semibold text-gray-800 dark:text-gray-100 min-w-[100px]">Email:</span>
        <span className="text-gray-600 dark:text-gray-300 break-all">{contactDetails.email}</span>
      </div>
      <div className="flex items-center gap-4">
        <span className="font-semibold text-gray-800 dark:text-gray-100 min-w-[100px]">Phone:</span>
        <span className="text-gray-600 dark:text-gray-300">{contactDetails.phone}</span>
      </div>
      <div className="flex items-center gap-4">
        <span className="font-semibold text-gray-800 dark:text-gray-100 min-w-[100px]">Location:</span>
        <span className="text-gray-600 dark:text-gray-300">{contactDetails.location}</span>
      </div>
    </div>
  );
};

export default ContactDetails;
